import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { DropDownList } from "../../models/dropdownlist.model";
import { UserSecurityTenderModel } from "../../models/Principal/user-security-tender.model";
@Component({
    selector: '',
    templateUrl: 'user-security-tender.html',
})
export class UserSecurityTenderComponent implements OnInit {

    userSelected: number = 0;
    userNameSelected: string = "";
    userType: string = "";
    fields: Object = { text: 'label', value: 'value' };
    userTypeDDL: Array<any> = [
        { label: "Tender Process", value: "ZPV" }
        //{ label: "Principal User", value: "PRN" }
    ];

    lstRight: Array<UserSecurityTenderModel> = [];
        
    constructor(private http: HttpService, private helper: HelperService) {

    }
    userDDL: Array<DropDownList> = [];

    ngOnInit() {

    }
    getUserDDL(type:string) {
        this.http.get('api/PrincipalUser/GetUserByTypeDDL?userType=' + type, res => {
            this.userDDL = res;
        }, null);
    }
    loadRight() {
        this.http.get('api/PrincipalUser/GetUserSecurityTender?userID=' + this.userSelected, res => {
            this.lstRight = res;
        }, null);
    }

    loadRightByUserName() {
        this.http.get('api/PrincipalUser/GetUserSecurityTenderByUserName?userName=' + this.userNameSelected, res => {
            debugger
            this.lstRight = res;
        }, null);
    }

    onChangeUser(e) {
        this.userSelected = e.value;
        this.userNameSelected = e.itemData.label;
        //this.loadRight();
        this.loadRightByUserName();
    }
    onChangeUserType(e) {
        this.userType = e.value;
        this.getUserDDL(this.userType)
    }
    onCheckRight(titleId: number, rightName: string) {
        var obj = this.lstRight.filter(x => x.ID == titleId)[0];
        if (obj) {
            var index = this.lstRight.findIndex(x => x.ID == titleId);
            if (rightName == "View") {
                obj.V = !obj.V;
            }
            if (rightName == "Edit") {
                obj.E = !obj.E;
            }
            if (rightName == "Delete") {
                obj.D = !obj.D;
            }
            if (rightName == "Unlock") {
                obj.U = !obj.U;
            }
            this.lstRight[index] = obj;
        }
    }

    saveUserRightonTender() {
        let dataSave = {
            UserID: this.userSelected,
            UserName: this.userNameSelected,
            UserType: this.userType,
            Security: this.lstRight
        };

        this.http.save('api/PrincipalUser/SaveUserSecurityTender', dataSave, res => {
            //this.loadRight();
            this.loadRightByUserName();
        }, null);
    }
}
